<template>
	<div>
		<v-layout row justify-space-between>
			<v-flex xs10 d-flex>
				<v-flex xs2
					v-for="filter in filterActive"
					:key="filter.id"
					class="filter-list">
					<v-btn
						class="mr-0"
						:class="{'active': filter.active }"
						@click="selectFilter(filter)"
					>
						{{ filter.name }}
					</v-btn>
				</v-flex>
			</v-flex>
			<v-flex xs2>
				<v-flex>
					<button-create text="Crear Vendedor" :href="createHref"></button-create>
				</v-flex>
			</v-flex>
		</v-layout>
		<v-layout row>
			<v-flex>
				<table-run
					switch-value="flagActive"
					:include-switch="true"
					:columns="columns"
					:rows="rows"
					:include-delete="false"
					:include-export-to-excel="false"
					:include-options="true"
					:include-settings="true"
					:option-buttons="optionButtons"
					@on-sortable-event="columnSortableEvent"
					@on-search-event="searchByColumn"
					@go-to-edit-page="goToEdit"
					@custom-button="customButton"
					@on-change-state="changeState">
					<template slot="rows" scope="props">
						<td>{{ props.row.name }}</td>
						<td>{{ props.row.lastname }}</td>
						<td>{{ props.row.subsidiary }}</td>
						<td>{{ props.row.email }}</td>
						<td>{{ props.row.sales }}</td>
					</template>
				</table-run>
				<div class="text-xs-right mt-3">
					<v-pagination
					:length="totalPages"
					v-model="params.page"
					:total-visible="pagesVisible"
					@input="loadData"
					></v-pagination>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import TableRun from 'table-run';
import lib from '@/shared/lib';
import ButtonCreate from '@/components/shared/ButtonCreate';

const { setNewProperty, updateItemInCollection, compose } = lib;

function created() {
	this.loadData();
}

async function loadData() {
	const url = `${process.env.PMS_URL}/sellers`;
	const response = await this.$http.get(url, { params: this.params });
	this.rows = response.data.data;
	this.totalPages = Number(response.headers.map['x-last-page']);
}

function customButton() {}

function goToEdit({ id }) {
	this.$router.push({ name: 'sellers-edit', params: { sellerId: id } });
}

function searchByColumn(search) {
	this.params.search = search;
	this.loadData();
}

function selectFilter(item) {
	this.filterActive = this.filterActive.map(
		compose(
			updateItemInCollection(
				item,
				'id',
				'active',
				true,
			),
			setNewProperty('active', false),
		),
	);
	this.params.flagActive = item.value;
	this.loadData();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	this.params.sortField = newColumn[0].code;
	this.params.sortDirection = newColumn[0].isSortable.up ? 'asc'
		: 'desc';
	this.loadData();
}

function pagesVisible() {
	return this.totalPages < 5 ? this.totalPages : 5;
}

async function changeState(row) {
	const url = `${process.env.PMS_URL}/employees/${row.id}`;
	const body = { flagActive: row.flagActive === 1 };
	await this.$http.patch(url, body);
}

function data() {
	return {
		columns: [
			{ id: 1, name: 'Nombre', code: 'name', isSortable: { down: true, up: false } },
			{ id: 2, name: 'Apellido', code: 'lastname', isSortable: { down: true, up: false } },
			{ id: 3, name: 'Sucursal', code: 'subsidiary', isSortable: { down: true, up: false } },
			{ id: 4, name: 'Correo Electrónico', code: 'email', isSortable: { down: true, up: false } },
			{ id: 5, name: 'Venta Mensual', code: 'sales', isSortable: { down: true, up: false } },
		],
		createHref: { name: 'sellers-new' },
		filterActive: [
			{ id: 1, name: 'Todos', active: true, value: null },
			{ id: 2, name: 'Activos', active: false, value: 1 },
			{ id: 3, name: 'Desactivados', active: false, value: 0 },
		],
		optionButtons: [
			{
				id: 1,
				icon: 'bar_chart',
			},
		],
		params: {
			page: 1,
			perPage: 20,
			search: null,
			flagActive: null,
		},
		rows: [],
		totalPages: null,
	};
}

export default {
	name: 'seller-list',
	components: {
		ButtonCreate,
		TableRun,
	},
	computed: {
		pagesVisible,
	},
	created,
	data,
	methods: {
		changeState,
		columnSortableEvent,
		customButton,
		goToEdit,
		loadData,
		searchByColumn,
		selectFilter,
	},
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// List.vue?ea09b3a4